export default "__VITE_ASSET__cfd73f49__"